export { default as ModernSlaveryActTransparencyStatement } from './ModernSlaveryActTransparencyStatement';
